var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useContext, useEffect, useState } from 'react';
import { Image, View } from 'react-native';
import { StateConfigContext } from '../../providers';
import { checkIsPlatform, getTestId } from '../../utils';
import { DynamicSvg } from '../dynamic-svg';
import { Notifier } from '../notifier';
import { Typography } from '../typography';
import { getAvatarProps, getAvatarStyles, getLabelTypes } from './AvatarStyles';
export var Avatar = forwardRef((props, ref) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  var stateContext = useContext(StateConfigContext);
  var avatarProps = getAvatarProps(props, stateContext);
  var avatarStyles = getAvatarStyles(avatarProps);
  var initials = avatarProps.initials,
    config = avatarProps.config,
    size = avatarProps.size,
    iconName = avatarProps.iconName,
    iconProps = avatarProps.iconProps,
    imageUrl = avatarProps.imageUrl,
    onErrorImageUrl = avatarProps.onErrorImageUrl,
    _avatarProps$imageRes = avatarProps.imageResizeMode,
    imageResizeMode = _avatarProps$imageRes === void 0 ? 'contain' : _avatarProps$imageRes,
    variant = avatarProps.variant,
    hasDot = avatarProps.hasDot,
    _avatarProps$dotState = avatarProps.dotState,
    dotState = _avatarProps$dotState === void 0 ? 'default' : _avatarProps$dotState,
    style = avatarProps.style,
    imageProps = avatarProps.imageProps,
    outerContainerStyles = avatarProps.outerContainerStyles,
    _avatarProps$status = avatarProps.status,
    status = _avatarProps$status === void 0 ? 'default' : _avatarProps$status,
    _avatarProps$testID = avatarProps.testID,
    testID = _avatarProps$testID === void 0 ? 'Avatar' : _avatarProps$testID,
    showNotifier = avatarProps.showNotifier,
    notifierProps = avatarProps.notifierProps,
    restProps = __rest(avatarProps, ["initials", "config", "size", "iconName", "iconProps", "imageUrl", "onErrorImageUrl", "imageResizeMode", "variant", "hasDot", "dotState", "style", "imageProps", "outerContainerStyles", "status", "testID", "showNotifier", "notifierProps"]);
  var isImageVariant = variant == 'image';
  var isIconVariant = variant == 'icon';
  var isInitialsVariant = variant == 'initials';
  var _j = imageProps || {},
    imgStyle = _j.style,
    restImgProps = __rest(_j, ["style"]);
  var _useState = useState(imageUrl),
    imgUrl = _useState[0],
    setImgUrl = _useState[1];
  var avatarColor = (_b = (_a = config === null || config === void 0 ? void 0 : config.state) === null || _a === void 0 ? void 0 : _a[status]) === null || _b === void 0 ? void 0 : _b.color;
  var notifierState = hasDot ? dotState : notifierProps === null || notifierProps === void 0 ? void 0 : notifierProps.state;
  if (props === null || props === void 0 ? void 0 : props.disabled) {
    notifierState = 'disabled';
  }
  useEffect(() => {
    setImgUrl(imageUrl);
  }, [imageUrl]);
  return _jsxs(View, Object.assign({
    style: [avatarStyles.outerContainer, outerContainerStyles]
  }, getTestId(testID, 'avatarOuterContainer'), {
    children: [_jsxs(View, Object.assign({
      ref: ref,
      style: [avatarStyles.container, style]
    }, restProps, getTestId(testID), {
      children: [isImageVariant && _jsx(Image, Object.assign({
        source: {
          uri: imgUrl
        },
        resizeMode: imageResizeMode,
        style: [avatarStyles.image, imgStyle]
      }, restImgProps, getTestId(testID, 'imageUrl'), {
        onError: () => {
          if (onErrorImageUrl) setImgUrl(onErrorImageUrl);
        }
      })), isInitialsVariant && initials && _jsx(Typography, Object.assign({
        text: (_c = initials === null || initials === void 0 ? void 0 : initials.substring(0, 2)) === null || _c === void 0 ? void 0 : _c.toUpperCase(),
        type: getLabelTypes(size),
        color: avatarColor
      }, getTestId(testID, initials))), isIconVariant && !!iconName && _jsx(DynamicSvg, Object.assign({
        iconName: iconName,
        style: avatarStyles.svg,
        fontSize: (_f = (_e = (_d = avatarProps === null || avatarProps === void 0 ? void 0 : avatarProps.config) === null || _d === void 0 ? void 0 : _d.size) === null || _e === void 0 ? void 0 : _e[size]) === null || _f === void 0 ? void 0 : _f.iconSize,
        color: avatarColor
      }, iconProps, checkIsPlatform('web') && {
        role: 'none'
      }, getTestId(testID, iconName)))]
    })), (hasDot || showNotifier) && _jsx(Notifier, Object.assign({
      hasDot: hasDot,
      style: hasDot || (notifierProps === null || notifierProps === void 0 ? void 0 : notifierProps.hasDot) ? avatarStyles.dot : avatarStyles.notifier,
      size: (_h = (_g = config === null || config === void 0 ? void 0 : config.size) === null || _g === void 0 ? void 0 : _g[size]) === null || _h === void 0 ? void 0 : _h.notifierSize
    }, getTestId(testID, 'notifier'), notifierProps, {
      state: notifierState
    }))]
  }));
});